import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const LogOutLinkDefaultBox = styled.a`
    display: block;
    padding: 1rem 0rem;
    font-size: 1.4rem;
    line-height: 1;
    transition: color 0.2s ease;
    text-align: center;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        color: ${props => props.theme.colors.textLight};
    }

    &:hover {
        color: ${props => props.theme.colors.textContrast};
    }
`;

const LogOutLinkCasino777Box = styled(LogOutLinkDefaultBox)`
    padding: 1rem 0rem;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.4rem;
`;

const LogOutLinkMrGreenBox = styled(LogOutLinkDefaultBox)`
    &:hover {
        background-color: ${props => props.theme.colors.background};
    }
`;

export const LogOutLinkBox = styledByTheme(LogOutLinkDefaultBox)
    .forCasino777(LogOutLinkCasino777Box)
    .forMrGreen(LogOutLinkMrGreenBox)
    .apply();
